module.exports = __webpack_public_path__ + "static/media/SDFSA_7-317w.9e5cb4fa.jpg";